export default __webpack_public_path__ + "static/media/h5-section2-bg1.d9be0e5e.png";